import {Component, Input, ViewChild} from '@angular/core';
import {DxFormComponent} from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import {AjaxService} from 'AjaxService';
import {SpinnerService} from '@services/spinner.service';

interface IOertlichePruefungenEinrichtungen {
  eId: number;
  name: string;
  adresse: string;
  oertPruef: IOertlichePruefungenItemEinrichtungen[];
}

interface IOertlichePruefungenItemEinrichtungen {
  id: number;
  pruefungstermin: Date;
  pruefungstext: string;
  auflagen: IAuflagenItemEinrichtungen[];
}

interface IOertlichePruefungenWithAuflagenItemEinrichtungen {
  eId: number;
  pruefungstermin: Date;
  pruefungstext: string;
  auflagen: IAuflagenItemEinrichtungen[];
}

interface IAuflagenItemEinrichtungen {
  id: number;
  termin: Date;
  beschreibung: string;
  erledigungsdatum?: Date;
}

@Component({
    selector: 'cz-oertliche-pruefung-popup',
    templateUrl: './oertliche-pruefung-popup.component.html',
    styleUrls: ['./oertliche-pruefung-popup.component.css'],
    standalone: false
})
export class OertlichePruefungPopupInternComponent {
  loading: boolean = true;
  @ViewChild('PopupForm', {static: false}) form1: DxFormComponent;
  @ViewChild('auflForm', {static: false}) auflForm: DxFormComponent;
  @ViewChild('auflErlForm', {static: false}) auflErlForm: DxFormComponent;

  popupVisible: boolean = false;
  @Input() eId: number;

  popupAuflagenVisible: boolean = false;
  popupAuflagenErledigtVisible: boolean = false;

  selectedOertPrf: IOertlichePruefungenItemEinrichtungen;
  selectedAuflageErledigt: IAuflagenItemEinrichtungen;

  resultOertPrf: IOertlichePruefungenWithAuflagenItemEinrichtungen = {
    pruefungstermin: new Date(),
    auflagen: [],
  } as IOertlichePruefungenWithAuflagenItemEinrichtungen;

  einrichtungen: IOertlichePruefungenEinrichtungen[];

  constructor(private ajaxService: AjaxService, private spinnerService: SpinnerService) {
    this.hideOePopup = this.hideOePopup.bind(this);
    this.onClickAuflagenPosPopupOk = this.onClickAuflagenPosPopupOk.bind(this);
    this.hideOeAuflagenPopup = this.hideOeAuflagenPopup.bind(this);
    this.onClickAuflagenErledigtPopupOk = this.onClickAuflagenErledigtPopupOk.bind(this);
    this.hideOeAuflagenErledigtPopup = this.hideOeAuflagenErledigtPopup.bind(this);
  }

  onContentReady(e: any) {
    e.component.columnOption('command:edit', {
      visibleIndex: -1,
    });

    e.component.columnOption('command:expand', {
      visibleIndex: -2,
    });
  }

  load() {
    if (!this.eId) {
      return;
    }

    this.startLoading();
    this.ajaxService.post<IOertlichePruefungenEinrichtungen[]>('api/OertlichePruefungen/GetOertlPrf', this.eId).subscribe({
      next: (response) => {
        this.einrichtungen = response;
        this.stopLoading();
      },
      error: (e) => {
        this.stopLoading();
        throw e;
      },
    });
  }

  showPopup() {
    this.popupVisible = true;
    this.load();
  }

  onHiddenOertPrfPopup(e: any) {
    this.popupVisible = false;
    this.loading = true;
    this.einrichtungen = null;
  }

  onAddOertPrfClick(e: any, data: {id: any; eId: any}) {
    e.stopPropagation();

    this.resultOertPrf = {
      pruefungstermin: new Date(),
      eId: data.eId,
      auflagen: [],
    } as IOertlichePruefungenWithAuflagenItemEinrichtungen;

    this.popupAuflagenVisible = true;
  }

  onClickAuflagenPosPopupOk() {
    const validationResult = this.auflForm.instance.validate();
    if (!validationResult.isValid) {
      let msg = '';
      for (const err of validationResult.brokenRules) {
        msg += err.message + '\r\n';
      }

      notify(
        {
          message: msg,
          width: 600,
        },
        'error',
        3000
      );
    } else {
      this.ajaxService.post<IOertlichePruefungenEinrichtungen[]>('api/OertlichePruefungen/CreateOertlPrf', this.resultOertPrf).subscribe({
        next: (response) => {
          this.einrichtungen = response;
          this.stopLoading();
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
      this.popupAuflagenVisible = false;
    }
  }

  showOertPrfAuflagen: number = -1;

  onOpenAuflagenClick(op: any) {
    if (this.showOertPrfAuflagen !== op.id) {
      this.showOertPrfAuflagen = op.id;
    } else {
      this.showOertPrfAuflagen = null;
    }
  }

  isAllOpOk(op: IOertlichePruefungenEinrichtungen): boolean {
    for (let i = 0; i < op.oertPruef.length; i++) {
      const _op = op.oertPruef[i];
      const auflNotOk = _op.auflagen.find((x) => x.erledigungsdatum === null);
      if (auflNotOk) {
        return false;
      }
    }
    return true;
  }

  isAllAuflagenOk(op: IOertlichePruefungenItemEinrichtungen): boolean {
    const auflNotOk = op.auflagen.find((x) => x.erledigungsdatum === null);
    if (auflNotOk) {
      return false;
    }

    return true;
  }

  onOpenAuflagenErledigtPopClick(al: IAuflagenItemEinrichtungen) {
    this.selectedAuflageErledigt = al;
    this.popupAuflagenErledigtVisible = true;
  }

  onHiddenAuflagenErledigtPopup(event: any) {
    this.popupAuflagenErledigtVisible = false;
    this.selectedAuflageErledigt = null;
  }

  onClickAuflagenErledigtPopupOk() {
    const validationResult = this.auflErlForm.instance.validate();
    if (!validationResult.isValid) {
      let msg = '';
      for (const err of validationResult.brokenRules) {
        msg += err.message + '\r\n';
      }

      notify(
        {
          message: msg,
          width: 600,
        },
        'error',
        3000
      );
    } else {
      this.ajaxService.post<IOertlichePruefungenEinrichtungen[]>('api/OertlichePruefungen/SetAuflageErledigt', {auflage: this.selectedAuflageErledigt, eId: this.eId}).subscribe({
        next: (response) => {
          this.einrichtungen = response;
          this.stopLoading();
        },
        error: (e) => {
          this.stopLoading();
          throw e;
        },
      });
      this.popupAuflagenErledigtVisible = false;
    }
  }

  onHiddenAuflagenPopup(event: any) {
    this.popupAuflagenVisible = false;
  }

  hideOePopup() {
    this.popupVisible = false;
  }

  hideOeAuflagenPopup() {
    this.popupAuflagenVisible = false;
  }

  hideOeAuflagenErledigtPopup() {
    this.popupAuflagenErledigtVisible = false;
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }
}
